// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.c3z4y{gap:8px}.U7svN{gap:4px;align-items:center}.vTnIX{display:flex;flex-direction:column;gap:8px;max-height:215px;overflow-y:auto}.ZpbnN{display:flex;flex-direction:column;--draggable-grid-item-radius: 8px}.kz243{margin-left:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `c3z4y`,
	"includedServicesHeader": `U7svN`,
	"servicesWrapper": `vTnIX`,
	"draggableServicesWrapper": `ZpbnN`,
	"addServices": `kz243`
};
export default ___CSS_LOADER_EXPORT___;
